import { Fragment, useState, useEffect } from 'react';
import QRCode from 'qrcode';

import Balance from 'components/common/balance/balance';
import CopyIcon from 'components/icons/CopyIcon';
import useCopyToClipboard from 'lib/hooks/use-copy-to-clipboard';

import { useAppSelector } from 'redux/use-hooks';
import { selectAccountId } from 'redux/slices/account';
import { selectActiveToken } from 'redux/slices/tokens';

import {
  StyledInputButton,
  StyledInputLabel,
  StyledInputValue,
  StyledInputWrapper,
  StyledLabel,
  StyledQrCodeWrapper
} from '../../send-view.style';

const ReceiveView = () => {
  const [copied, copy] = useCopyToClipboard(700);
  const accountId = useAppSelector(selectAccountId);
  const activeToken = useAppSelector(selectActiveToken);
  const [qrCodeString, setQRCodeString] = useState(accountId);

  useEffect(() => {
    QRCode.toDataURL(
      accountId,
      {
        errorCorrectionLevel: 'H',
        type: 'image/webp',
        quality: 1,
        margin: 0,
        scale: 1,
        width: 140
      },
      function (err, url) {
        if (err) throw err;

        setQRCodeString(url);
      }
    );
  }, [accountId]);

  return (
    <Fragment>
      <StyledQrCodeWrapper>
        <img style={{ width: 140, height: 140 }} src={qrCodeString} />
      </StyledQrCodeWrapper>
      <StyledLabel>Account ID</StyledLabel>
      <StyledInputWrapper mb="20px">
        <StyledInputLabel>{accountId}</StyledInputLabel>
        <StyledInputValue flex="none">
          <StyledInputButton type="button" onClick={() => copy(accountId)}>
            <CopyIcon />
            {copied ? 'Copied!' : 'Copy'}
          </StyledInputButton>
        </StyledInputValue>
      </StyledInputWrapper>
      <StyledInputWrapper alignItems="flex-start">
        <StyledInputLabel>Available balance</StyledInputLabel>
        <StyledInputValue>
          <Balance
            amount={activeToken?.balance}
            symbol={activeToken.onChainFTMetadata.symbol}
            nearTokenFiatValueUSD={activeToken.fiatValueMetadata?.usd}
          />
        </StyledInputValue>
      </StyledInputWrapper>
    </Fragment>
  );
};

export default ReceiveView;
